export type KinsCircleConstitutionRule = {
  id: string;
  title: string;
  rule: string;
  enforcement: 'BLOCK' | 'WARN' | 'DISPLAY_ONLY' | 'REQUIRE_CONNECTOR';
};

export const KINSCIRCLE_CONSTITUTION: KinsCircleConstitutionRule[] = [
  {
    id: 'bloodline-truth',
    title: 'Bloodline truth cannot be corrupted',
    rule: 'parent_ids are structural bloodline/adoptive/recognized-parent edges and must never be guessed or silently mutated.',
    enforcement: 'BLOCK',
  },
  {
    id: 'recognized-family-is-family',
    title: 'Recognized family is real family',
    rule: 'A person may be displayed as Aunt, Uncle, Grandparent, Cousin, or other family role by recognition/custom label without falsely creating blood ancestry.',
    enforcement: 'DISPLAY_ONLY',
  },
  {
    id: 'connector-required',
    title: 'Modern family links require a connector',
    rule: 'Co-parent, step-parent, in-law, recognized aunt/uncle, and non-blood extended roles must identify the child/person/partner they connect through.',
    enforcement: 'REQUIRE_CONNECTOR',
  },
  {
    id: 'coparent-not-spouse',
    title: 'Co-parent is not spouse',
    rule: 'Co-parents sit beside the shared child through parent_ids but do not receive a spouse/heart link unless explicitly marked spouse/partner.',
    enforcement: 'BLOCK',
  },
  {
    id: 'inlaw-via-spouse',
    title: 'In-laws connect through spouse links',
    rule: 'Son-in-law, daughter-in-law, parent-in-law, and spouse-side family are derived through spouse_id/partner connection, not bloodline parent_ids.',
    enforcement: 'BLOCK',
  },
  {
    id: 'no-silent-failure',
    title: 'No silent relationship failure',
    rule: 'Governor and UI must surface a clear reason when a relationship edge cannot be saved.',
    enforcement: 'BLOCK',
  },
];

export function getKinsCircleConstitution() {
  return KINSCIRCLE_CONSTITUTION;
}

export function constitutionSummary(): string {
  return KINSCIRCLE_CONSTITUTION
    .map((r) => `${r.id}: ${r.enforcement} — ${r.rule}`)
    .join('\n');
}
